import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqList } from "@/mocks/doumanData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="常见问题"
          title="进不去、地址失效、下载失败？先看这里"
          desc="下面整理了使用过程中最常被问到的八个问题，覆盖入口查找、地址变化、下载安装、账号与阅读设置等场景。"
        />

        <div className="mt-12 max-w-4xl mx-auto space-y-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="flex items-start gap-3">
                    <span className="shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-700 text-xs font-bold flex items-center justify-center mt-0.5">
                      Q
                    </span>
                    <span className="font-heading font-bold text-sm md:text-base text-foreground-950">{item.q}</span>
                  </span>
                  <i
                    className={`shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}